export default [
    {
        path: '/kanban/daily-orders',
        name: 'DailyOrdersKanban',
        meta: { authRequired: true },
        component: () => import('../views/canban/daily-orders.vue')
    },
    {
        path: '/kanban/daily-orders/:id',
        name: "DailyOrdersDetail",
        meta: {authRequired: true},
        component: () => import('../views/canban/order-detail.vue'),
    }
]
